/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { XC20Handler, XC20HandlerInterface } from "../XC20Handler";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "bridgeAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
    ],
    name: "ContractAddressNotWhitelisted",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "actual",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "expected",
        type: "uint256",
      },
    ],
    name: "UnexpectedValue",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "_bridgeAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "_resourceIDToTokenContractAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "_tokenContractAddressToTokenProperties",
    outputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bool",
        name: "isWhitelisted",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isBurnable",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "isSet",
            type: "bool",
          },
          {
            internalType: "uint8",
            name: "externalDecimals",
            type: "uint8",
          },
        ],
        internalType: "struct ERCHandlerHelpers.Decimals",
        name: "decimals",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "defaultDecimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
    ],
    name: "setBurnable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "executeProposal",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "args",
        type: "bytes",
      },
    ],
    name: "setResource",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type XC20HandlerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: XC20HandlerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class XC20Handler__factory extends ContractFactory {
  constructor(...args: XC20HandlerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "XC20Handler";
  }

  deploy(
    bridgeAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<XC20Handler> {
    return super.deploy(bridgeAddress, overrides || {}) as Promise<XC20Handler>;
  }
  getDeployTransaction(
    bridgeAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(bridgeAddress, overrides || {});
  }
  attach(address: string): XC20Handler {
    return super.attach(address) as XC20Handler;
  }
  connect(signer: Signer): XC20Handler__factory {
    return super.connect(signer) as XC20Handler__factory;
  }
  static readonly contractName: "XC20Handler";
  public readonly contractName: "XC20Handler";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): XC20HandlerInterface {
    return new utils.Interface(_abi) as XC20HandlerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): XC20Handler {
    return new Contract(address, _abi, signerOrProvider) as XC20Handler;
  }
}
